import { Text } from "@fluentui/react-components";
import Skeleton from "react-loading-skeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ListItemMobileProps } from "./ListItemMobile.types";
import { clsx } from "clsx/lite";

export default function ListItemMobile({
  icon,
  iconPrimary,
  primaryText,
  secondaryText,
  onClick,
}: ListItemMobileProps) {
  return (
    <button
      onClick={onClick}
      className="py-2 flex gap-4 flex-row justify-start items-center w-full"
    >
      <div className="w-6">
        {icon ? (
          <FontAwesomeIcon
            icon={icon}
            className={clsx(
              iconPrimary ? "text-primary" : "text-font-secondary",
              "text-2xl",
            )}
          />
        ) : (
          <Skeleton circle className="aspect-square" />
        )}
      </div>
      <div className="flex flex-col items-start justify-center grow">
        <Text className="w-full">{primaryText ?? <Skeleton />}</Text>
        <Text className="w-full text-font-secondary" size={300}>
          {secondaryText ?? <Skeleton />}
        </Text>
      </div>
    </button>
  );
}
